import * as React from "react";
import { createIcon } from "@chakra-ui/react";

const Compare = createIcon({
  path: (
    <path
      d="M10.9753 16V0H17.5005C19.3526 0 20.313 0.951768 20.313 2.77814V13.2219C20.313 15.0482 19.3526 16 17.5005 16H10.9753ZM2.81243 16C0.960343 16 0 15.0482 0 13.2219V2.77814C0 0.943194 0.960343 0 2.81243 0H9.32905V16H2.81243Z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 21 16",
});

export { Compare };
